import { Component, OnInit, ViewChild } from '@angular/core'
import { MissingPaymentGroup, NewPaymentGroupMap, PaymentTypeGroupMapClient } from '../shared/services/ppv.api'
import { Table } from 'primeng/table'
import { forkJoin } from 'rxjs'
import { SelectItem } from 'primeng/api'

@Component({
   selector: 'app-payment-group-map',
   templateUrl: './payment-group-map.component.html',
   styleUrls: ['./payment-group-map.component.scss'],
   standalone: false,
})
export class PaymentGroupMapComponent implements OnInit {
   public isLoading = true
   public saving = false
   public onlyUnmapped = true
   items: MissingPaymentGroup[] = []
   groupOptions: SelectItem[] = []
   changedIds: number[] = []

   @ViewChild('dt') table: Table

   constructor(private paymentTypeGroupMapClient: PaymentTypeGroupMapClient) {}

   ngOnInit(): void {
      this.loadData()
   }

   public loadData() {
      this.isLoading = true
      forkJoin({
         missingGroups: this.paymentTypeGroupMapClient.getGroups(this.onlyUnmapped),
         options: this.paymentTypeGroupMapClient.getOptions(),
      }).subscribe((result) => {
         this.items = result.missingGroups
         this.groupOptions = result.options.map((x) => ({ label: x, value: x }))
         this.isLoading = false
      })
   }

   public onItemChange(item: MissingPaymentGroup): void {
      this.changedIds.push(item.paymentTypeSkey)
   }

   onFilterShowOnlyUnmapped() {
      this.loadData()
   }

   public onSave(): void {
      if (this.changedIds.length === 0) {
         return
      }

      const changedItems = this.items
         .filter((x) => this.changedIds.indexOf(x.paymentTypeSkey) >= 0)
         .map(
            (x) =>
               ({
                  paymentTypeName: x.paymentTypeName,
                  groupName: x.mapGroup,
               } as NewPaymentGroupMap)
         )

      this.saving = true
      this.paymentTypeGroupMapClient.updatePaymentGroupMaps(changedItems).subscribe(() => {
         this.saving = false
         this.changedIds = []
      })
   }
}
